export default __webpack_public_path__ + "static/media/cowarkers.9de3e4af.png";